
/**
 * 受付時間表示切替
 */
export class ReceiptSeat {
  /**
   * 対象の要素オブジェクト
   */
  private readonly $element!: JQuery;

  /**
   * コンストラクタ
   * @param element 対象の要素セレクタ
   */
  constructor(element: string) {
    if(!$(element)) return;

    this.$element = $(element);
    this.closeReceipt();
  }

  /**
   * 日付取得
   */
  private closeReceipt(): void {
    const date = new Date();
    let month = date.getMonth() + 1, day = date.getDate();

    if (date.getHours() < 10) {
      day = date.getDate() - 1;

      if (day === 0) {
        month = month - 1;

        if (month === 0) {
          month = 12;
        }

        day = new Date(date.getFullYear(), month, 0).getDate();
      }
    }

    if ((date.getHours() === 20 && date.getMinutes() > 45) || date.getHours() > 20) {
      day = date.getDate();
    }

    const html = '<i>※</i>'+ month +'月'+ day +'日の受付は終了しました。<br class="hide-mdOver">(残席は、休業日を除く10:00~20:45で表示されます。)';
    this.$element.html(html);
  }
}